import { render, staticRenderFns } from "./DarkMode.vue?vue&type=template&id=6a618a48&scoped=true&"
import script from "./DarkMode.vue?vue&type=script&lang=js&"
export * from "./DarkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a618a48",
  null
  
)

export default component.exports